<template>
  <div class="contactUs">
    <div class="bg">
      <img class="qilin" src="../assets/images/contactUs/qilin.png" alt="">
      <div class="content">
        <img class="img1" src="../assets/images/contactUs/icon1.png" alt="">
        <div class="tel">+86-592-6661066</div>
        <div class="address">
          <img class="img2 icon" src="../assets/images/contactUs/icon2.png" alt="">
          <p>100 Liansheng  Road Jimei District Xiamen 361021</p>
        </div>
        <div class="address">
          <img class="img3 icon" src="../assets/images/contactUs/icon3.png" alt="">
          <p>+86-592-66610991</p>
        </div>
        <div class="address">
          <img class="img4 icon" src="../assets/images/contactUs/icon4.png" alt="">
          <p>kefu@sanlinst.com</p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "ContactUs",
  data() {
    return {};
  },
};
</script>

<style lang="scss" scoped>
.contactUs {
  margin-top: 130px;
  .bg{
    background-image: url('../assets/images/contactUs/bg.png');
    background-repeat: no-repeat;
    background-size: 100% 100%;
    height: 580px;
    display: flex;
    flex-direction: row;
    .qilin{
      margin-top: -140px;
    }
    .content{
      display: flex;
      flex-direction: column;
      margin-left: 130px;
      color: #FFFFFF;
      .img1{
        margin-top: 170px;
        height: 50px;
        width: 50px;
      }
      .tel{
        font-size: 48px;
        font-weight: 900;
      }
      .text{
        font-weight: 18px;
        line-height: 52px;
        font-weight: normal;
        border-bottom: 3px solid #FFFFFF;
      }
      
      .address{
        margin-top: 20px;
        line-height: 10px;
        display: flex;
        flex-direction: row;
        font-weight: normal;
        font-size: 16px;
        .img2{
          width: 18px;
          height: 22px;
        }
        p{
          margin-left: 30px;
          line-height: 22px;
        }
      }
    }
  }
  
}
</style>